import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { SKIP_LOADER_HEADER } from '../constants/http-headers';
import { LoadingStore } from '../store/loading.store';

/**
 * tracks the global loading spinner around each request, unless it carries the skip-loader header.
 * @returns {Observable<HttpEvent<unknown>>} the http event stream, unchanged.
 */
export const loaderInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const loadingStore = inject(LoadingStore);

  if (request.headers.has(SKIP_LOADER_HEADER)) {
    return next(request);
  }

  loadingStore.setLoading();

  return next(request).pipe(
    finalize(() => {
      loadingStore.unsetLoading();
    }),
  );
};
